import { useSnapshot } from 'valtio';
import { authStore, performLogout } from '../stores/auth.store';

export const useAuthStore = () => {
  const snap = useSnapshot(authStore);

  return {
    user: snap.user,
    token: snap.token,
    role: snap.role,
    isLoading: snap.isLoading,
    isError: snap.isError,
    error: snap.error,

    isAuthenticated: !!snap.token && !!snap.user,
    isAdmin: snap.role === 'admin' || snap.role === 'super_admin',
    isAssistant: snap.role === 'assistant' || snap.role === 'serviceProvider',
    isUser: snap.role === 'user',
    userName: snap.user
      ? `${snap.user.firstName || ''} ${snap.user.lastName || ''}`.trim()
      : '',

    actions: {
      setUser: authStore.setUser,
      setToken: authStore.setToken,
      setRole: authStore.setRole,
      setLoading: authStore.setLoading,
      setError: authStore.setError,
      reset: authStore.reset,
      logout: performLogout,
    },
  };
};
